'use client';

import { IconDotsVertical, IconLogout, IconUserCircle } from '@tabler/icons-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from '@/components/ui/sidebar';
import { useSession } from '@/hooks/use-session';

export function NavUser() {
  const { isMobile } = useSidebar();
  const { session, deleteSession } = useSession();

  if (!session) {
    return null;
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="rounded-[10px] hover:bg-white/[0.04] data-[state=open]:bg-white/[0.06] data-[state=open]:text-white"
            >
              <div className="relative shrink-0">
                <Avatar className="h-8 w-8">
                  <AvatarImage src={session?.avatarUrl || undefined} alt={session?.name || ''} />
                  <AvatarFallback className="bg-white/[0.08] text-white/60 text-xs">
                    {session?.name?.charAt(0) || 'A'}
                  </AvatarFallback>
                </Avatar>
                <div className="-bottom-0.5 -right-0.5 absolute size-2.5 rounded-full border-[1.5px] border-sidebar bg-emerald-400" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold text-[13px] text-white/90">
                  {session?.name}
                </span>
                <span className="truncate text-[11px] text-white/30">{session?.email}</span>
              </div>
              <IconDotsVertical className="ml-auto size-4 text-white/20" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 border-white/[0.08] bg-[#0D1117]"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8">
                  <AvatarImage src={session?.avatarUrl || undefined} alt={session?.name || ''} />
                  <AvatarFallback className="bg-white/[0.08] text-white/60 text-xs">
                    {session?.name?.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium text-white/90">{session?.name}</span>
                  <span className="truncate text-white/40 text-xs">{session?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator className="bg-white/[0.06]" />
            <DropdownMenuItem className="cursor-pointer text-white/70 hover:text-white focus:text-white">
              <IconUserCircle className="text-white/40" />
              Account
            </DropdownMenuItem>
            <DropdownMenuSeparator className="bg-white/[0.06]" />
            <DropdownMenuItem
              onClick={deleteSession}
              className="cursor-pointer text-white/70 hover:text-white focus:text-white"
            >
              <IconLogout className="text-white/40" />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
